import { Routes } from '@angular/router';
import { Home } from '../../app/components/home/home';
import { AuthGuard } from '../../app/guards/auth.guard';
import { RoleRoutingGuard } from '../../app/guards/role-routing.guard';
import { FeatureFlagGuard } from '../../app/guards/feature-flag.guard';
import { MaintenanceGuard } from '../../app/guards/maintenance.guard';
import { ActionPermissionResolver } from '../../app/guards/action-permission.resolver';
import { DeniedComponent } from '../components/denied/denied.component';
import { NotFoundComponent } from '../components/notfound/notfound.component';
import { MaintenanceComponent } from '../components/maintenance/maintenance';

export const routes: Routes = [  
 {  
   path: '',  
   redirectTo: '/home',  
   pathMatch: 'full'  
 },  
 {  
   path: 'home',  
   loadComponent: () => import('../../app/components/home/home').then(m => m.Home),
   title: 'QRM | Home',
   canActivate: [AuthGuard, MaintenanceGuard, RoleRoutingGuard]  
  },
  {
    path: 'document-repository/:programId',
    loadComponent: () => import('../components/document-list/document-list').then(m => m.DocumentList),
    canActivate: [AuthGuard, MaintenanceGuard]
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, MaintenanceGuard],
    loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard, MaintenanceGuard],
    loadChildren: () => import('./reports/reports.routes').then(m => m.reportsRoutes)
  },
   {
    path: 'dashboards',
    canActivate: [AuthGuard, MaintenanceGuard],
    loadChildren: () => import('./dashboards/dashboard.routes').then(m => m.DashboardRoutes)
  },
  {
    path: 'engagementdetails/:engagementId',
    title: 'QRM | QRS Survey Form',
    loadComponent: () => import('../components/dashboards/qrs-survey-form/qrs-survey-form').then(m => m.QrsSurveyForm),
    canActivate: [AuthGuard, MaintenanceGuard, FeatureFlagGuard],
    data: { featureFlag: 'ENABLE_QRS_ENGAGEMENT_DETAILS_PAGE', allowedRoles: ['LER', 'LEP', 'Quality Champ', 'Program Admin', 'QRM'] }
  },
  {
    path: 'audit-trail/:engagementId',
    title: 'QRM | Audit Trail',
    loadComponent: () => import('../components/dashboards/common/audit-trail-component/audit-trail-component').then(m => m.AuditTrailComponent),
    canActivate: [AuthGuard, MaintenanceGuard, FeatureFlagGuard],
    data: { featureFlag: 'ENABLE_QRS_PROGRAM_FEATURE', allowedRoles: ['LER', 'Quality Champ', 'Program Admin'] }
  },
  {
    path: 'program-audit-trail',
    title: 'QRM | Audit Trail',
    loadComponent: () => import('../components/dashboards/common/custom-audit-trail-component/custom-audit-trail-component').then(m => m.CustomAuditTrailComponent),
    canActivate: [AuthGuard, MaintenanceGuard, FeatureFlagGuard],
    data: { featureFlag: 'ENABLE_QRS_PROGRAM_FEATURE', allowedRoles: ['Program Admin'] }
  },
  {  
   path: 'notfound',  
   component: NotFoundComponent
  },
   {  
   path: 'denied',  
   component: DeniedComponent
  },
  {
   path: 'maintenance',
   component: MaintenanceComponent
  },
  {
    path: 'program',
    canActivate: [AuthGuard, MaintenanceGuard],
    loadChildren: () => import('../components/risk-category/risk-category-routing.module').then(m => m.RiskCategoryRoutingModule)
  }
  
];
